import { ID_OTHER_AUTHORITY } from 'civil-status/components/step/form/last-step/accordions/section/list/list-authority';
import { ID_COMMUNICATION } from 'civil-status/components/step/form/last-step/accordions/section/list/list-communication';
import { ID_OPPOSITION } from 'civil-status/components/step/form/last-step/accordions/section/list/list-opposition';
import { ID_PUBBLICATIONS } from 'civil-status/components/step/form/last-step/accordions/section/list/list-publication';
import { CodeSectionRiconsocimentoList } from 'civil-status/constants/code-section-riconsocimento-list';
import { CodeSection } from 'civil-status/constants/code-subject-section';
import { CodeTypeAct } from 'civil-status/constants/code-type-act';
import { IdPropertyRegime } from 'civil-status/constants/id-property-regime';
import { initialConditionsItem } from 'civil-status/constants/initial-values-step';
import { KeySections } from 'civil-status/constants/keys-subjects-section';
import {
  AnnotazioneModificativa,
  AttoCollegato,
  CertificatoSanitario,
  CertificatoUnioneCivileList,
  Composizione,
  Consenso,
  DataWizardAct,
  DatiAnnotazioneList,
  DatiAssenso,
  DatiDichiarante,
  DatiEventoCittadinanza,
  DatiEventoMorte,
  DatiEventoRiconoscimento,
  DatiIntegrativiTrascrizione,
  DatiMorte,
  EnteDichiaranteList,
  Evento,
  Impedimento,
  Luogo,
  MatrimonioAtti,
  NegoziazioneAssistita,
  Pubblicazione,
  PublicationVM,
  RegimePatrimoniale,
  Richiedente,
  Riconciliazione,
  RiconoscimentoList,
  RiferimentiPubblicazione,
  ScioglimentoUnioneCivileAtti,
  SectionVM,
  Separazione,
  StatoCivile,
  TrascrizioneCittadinanza,
  TrascrizioneMatrimonioAtti,
  TrascrizioneMorte,
  TrascrizioneNascita,
  TrascrizioneSeparazioneAtti,
  TrascrizioneUnioneCivile,
  UnioneCivileAtti,
} from 'civil-status/view-models/step-form';
import { DateTime } from 'luxon';
import {
  ForeignStateVM,
  ID_ALTRO_STATO,
  LABEL_ALTRO_STATO,
} from 'shell/components/shared/foreign-state-list';
import { ID_ALTRO_COMUNE, LABEL_ALTRO_COMUNE } from 'shell/components/shared/municipality-list';
import { ID_ITALIAN_NATION } from 'shell/constants/id-italian-nation';

const transformSectionDead = (
  castedDatiMorte?: DatiMorte,
  castedDatiEventoMorte?: DatiEventoMorte,
  castedStatoCivile?: StatoCivile,
  castedEvento?: Evento,
  castedDatiDichiarante?: DatiDichiarante
): Record<string, SectionVM> => {
  const res: Record<string, SectionVM> = {};

  if (!(castedDatiMorte || castedDatiEventoMorte)) {
    return res;
  }

  const keySection = `section-${castedDatiMorte?.codiceSezione?.trim()}`;

  const isOtherState = castedDatiMorte?.idStatoMorte?.toString() === ID_ALTRO_STATO;
  const isOtherMunicipality = castedDatiMorte?.idComuneMorte?.toString() === ID_ALTRO_COMUNE;

  res[keySection] = {
    isSaved: true,
    // castedDatiMorte
    isDatePresumed: Boolean(castedDatiMorte?.dataMortePresuntaDa),
    numeroNullaOsta: castedDatiMorte?.nrNullaOsta,
    datePresumedStart: castedDatiMorte?.dataMortePresuntaDa
      ? DateTime.fromISO(castedDatiMorte?.dataMortePresuntaDa)
      : null,
    datePresumedEnd: castedDatiMorte?.dataMortePresuntaA
      ? DateTime.fromISO(castedDatiMorte?.dataMortePresuntaA)
      : null,
    notePresumed: castedDatiMorte?.noteDataPresuntaMorte || '',
    dateDeath: castedDatiMorte?.dataMorte ? DateTime.fromISO(castedDatiMorte?.dataMorte) : null,
    timeDeath:
      castedDatiMorte?.oraMorte?.toString() || castedDatiMorte?.minutoMorte?.toString()
        ? DateTime.fromFormat(
            `${
              castedDatiMorte.oraMorte?.toString().length === 1
                ? `0${castedDatiMorte.oraMorte}`
                : castedDatiMorte.oraMorte || '00'
            }:${
              castedDatiMorte.minutoMorte?.toString().length === 1
                ? `0${castedDatiMorte.minutoMorte}`
                : castedDatiMorte.minutoMorte || '00'
            }`,
            'HH:mm'
          )
        : null,
    placeDeath: castedDatiMorte?.luogoMorte || '',
    isForeign:
      !Boolean(castedDatiMorte?.idComuneMorte?.toString()) &&
      Boolean(castedDatiMorte?.idStatoMorte),
    italian: castedDatiMorte?.idComuneMorte
      ? {
          municipality: {
            id: castedDatiMorte?.idComuneMorte,
            code: castedDatiMorte?.idComuneMorte,
            description: isOtherMunicipality
              ? LABEL_ALTRO_COMUNE
              : castedDatiMorte?.nomeComuneMorte || '',
            idProvince: castedDatiMorte?.idProvinciaMorte || undefined,
            province: castedDatiMorte?.siglaProvincia || '',
          },
          otherMunicipality: isOtherMunicipality ? castedDatiMorte?.nomeComuneMorte : '',
        }
      : undefined,
    foreign: castedDatiMorte?.idStatoMorte
      ? {
          state: {
            value: isOtherState ? LABEL_ALTRO_STATO : castedDatiMorte.nomeStatoMorte || '',
            id: castedDatiMorte?.idStatoMorte,
            code: castedDatiMorte?.idStatoMorte?.toString(),
          },
          otherState: isOtherState ? castedDatiMorte.nomeStatoMorte : '',
          municipalityForeign: castedDatiMorte.nomeComuneEsteroMorte || '',
        }
      : undefined,
    address: castedDatiMorte?.indirizzoMorte || '',
    // castedDatiEventoMorte
    authority: castedStatoCivile?.autorita
      ? {
          id: castedStatoCivile?.autorita,
          value:
            castedStatoCivile?.autorita === ID_OTHER_AUTHORITY
              ? ''
              : castedDatiEventoMorte?.descTrasmissione || '',
        }
      : undefined,
    otherAuthority:
      castedStatoCivile?.autorita === ID_OTHER_AUTHORITY
        ? castedDatiEventoMorte?.descTrasmissione || ''
        : '',
    typeCommunication: castedDatiEventoMorte?.tipoTrasmissione
      ? {
          id: castedDatiEventoMorte?.tipoTrasmissione,
          value: '',
        }
      : undefined,
    dateCommunication: castedDatiEventoMorte?.dataTrasmissione
      ? DateTime.fromISO(castedDatiEventoMorte?.dataTrasmissione)
      : null,
    numberAppearing: castedDatiEventoMorte?.numComparenti?.toString() || '',
    // castedEvento
    isWithInterprete: castedEvento?.flagAusilioInterprete === '1',
    // castedDatiDichiarante
    conditionsItem: castedDatiDichiarante?.comprensione
      ? {
          id: castedDatiDichiarante?.comprensione,
          value: '',
        }
      : initialConditionsItem,
    reasonImpediment: castedDatiDichiarante?.motivoImpedimento || '',
  } as SectionVM;

  return res;
};

const transformSectionsEnteDichiarante = (
  castedEnteDichiaranteList?: Array<EnteDichiaranteList>,
  castedTrascrizioneMorte?: TrascrizioneMorte,
  castedDatiEventoRiconoscimento?: DatiEventoRiconoscimento,
  castedDatiEventoCittadinanza?: DatiEventoCittadinanza,
  castedImpedimentoList?: Array<Impedimento>,
  riconoscimentoList?: Array<RiconoscimentoList>,
  castedNegoziazioneAssistita?: NegoziazioneAssistita,
  castedStatoCivile?: StatoCivile,
  castedDatiIntegrativiTrascrizione?: DatiIntegrativiTrascrizione,
  castedTrascrizioneSeparazioneAtti?: TrascrizioneSeparazioneAtti
): Record<string, SectionVM> => {
  const dataEnteDichiaranteList = (castedEnteDichiaranteList || []).filter(
    (item) => item.sezione !== CodeSection.DATI_TRASCRIZIONE // escluso questo elemento gestito in trascrizione nascita
  );

  const res: Record<string, SectionVM> = {};

  if (dataEnteDichiaranteList.length === 0) {
    return res;
  }

  dataEnteDichiaranteList?.forEach((castedEnteDichiaranteListDataCurrent) => {
    const codiceSezione = castedEnteDichiaranteListDataCurrent?.sezione?.trim() || '';
    const keySection = `section-${codiceSezione}`;

    const isOtherState =
      castedEnteDichiaranteListDataCurrent?.idNazione?.toString() === ID_ALTRO_STATO;
    const isOtherMunicipality =
      castedEnteDichiaranteListDataCurrent?.idComune?.toString() === ID_ALTRO_COMUNE;

    const impedimentoCurrent = castedImpedimentoList?.find(
      (itemImpedimento) => itemImpedimento.sezione === codiceSezione
    );

    res[keySection] = {
      isSaved: true,
      // castedEnteDichiaranteList
      idEnteDichiarante: castedEnteDichiaranteListDataCurrent?.key?.idEnteDichiarante || undefined,
      isNotary:
        codiceSezione === CodeSection.ENTE_DICHIARANTE
          ? Boolean(castedEnteDichiaranteListDataCurrent?.dataTrascrizione)
          : false,
      documentDateFormation:
        codiceSezione !== CodeSection.DATI_TRASCRIZIONE_NEGOZ
          ? castedEnteDichiaranteListDataCurrent?.dataTrascrizione
            ? DateTime.fromISO(castedEnteDichiaranteListDataCurrent?.dataTrascrizione)
            : null
          : undefined,
      dateTranscription:
        codiceSezione === CodeSection.DATI_TRASCRIZIONE_NEGOZ
          ? castedEnteDichiaranteListDataCurrent?.dataTrascrizione
            ? DateTime.fromISO(castedEnteDichiaranteListDataCurrent?.dataTrascrizione)
            : null
          : undefined,
      documentExtremes: castedEnteDichiaranteListDataCurrent?.estremiDocumento || '',
      nameInstitution: castedEnteDichiaranteListDataCurrent?.nomeEnteDichiarante || '',
      rolo: castedEnteDichiaranteListDataCurrent.ruolo || '',
      italian: castedEnteDichiaranteListDataCurrent?.nomeComune
        ? {
            municipality: {
              description: isOtherMunicipality
                ? LABEL_ALTRO_COMUNE
                : castedEnteDichiaranteListDataCurrent?.nomeComune || '',
              id: castedEnteDichiaranteListDataCurrent?.idComune?.toString() || '',
              code: castedEnteDichiaranteListDataCurrent?.idComune,
              idProvince: castedEnteDichiaranteListDataCurrent?.idProvincia || undefined,
              province: castedEnteDichiaranteListDataCurrent?.siglaProvincia || '',
            },
            otherMunicipality: isOtherMunicipality
              ? castedEnteDichiaranteListDataCurrent?.nomeComune
              : '',
          }
        : undefined,
      documentDescription: castedEnteDichiaranteListDataCurrent?.trascrizione || '',
      foreign: castedEnteDichiaranteListDataCurrent?.idNazione
        ? {
            state: {
              id: castedEnteDichiaranteListDataCurrent?.idNazione.toString(),
              value: isOtherState
                ? LABEL_ALTRO_STATO
                : castedEnteDichiaranteListDataCurrent?.nomeNazione || '',
              code: castedEnteDichiaranteListDataCurrent?.idNazione.toString(),
            },
            otherState: isOtherState ? castedEnteDichiaranteListDataCurrent?.nomeNazione : '',
            locationForeign: castedEnteDichiaranteListDataCurrent.nomeComuneEstero || '',
            consulate: castedEnteDichiaranteListDataCurrent?.anagraficaConsolato
              ? {
                  id: castedEnteDichiaranteListDataCurrent?.anagraficaConsolato,
                  value: castedEnteDichiaranteListDataCurrent?.nomeAnagraficaConsolato || '',
                }
              : undefined,
          }
        : undefined,
      isForeign: castedEnteDichiaranteListDataCurrent?.idNazione !== ID_ITALIAN_NATION,
      address: castedEnteDichiaranteListDataCurrent?.indirizzo || '',
      // castedDatiEventoRiconoscimento
      presentationDocument: CodeSection.AUTORIZZAZIONE_RICONOSCIMENTO_PADRE
        ? castedDatiEventoRiconoscimento?.datiProdotti || ''
        : '',
      idDatiEventoRiconoscimento: CodeSection.AUTORIZZAZIONE_RICONOSCIMENTO_PADRE
        ? castedDatiEventoRiconoscimento?.key?.idDatiEventoRiconoscimento || undefined
        : undefined,
      // riconoscimentoList
      riconoscimentoList: CodeSectionRiconsocimentoList.includes(codiceSezione as CodeSection)
        ? riconoscimentoList
        : undefined,
      // castedTrascrizioneMorte
      documentRequestDate:
        codiceSezione === CodeSection.DATI_AUTORITA_MITTENTE &&
        castedTrascrizioneMorte?.dataComunicazione
          ? DateTime.fromISO(castedTrascrizioneMorte?.dataComunicazione)
          : null,
      // castedDatiEventoCittadinanza
      hiringTiming:
        codiceSezione === CodeSection.PUBBLICO_IMPIEGO
          ? castedDatiEventoCittadinanza?.tempoAssunzione || ''
          : undefined,
      // castedImpedimentoList
      reason: impedimentoCurrent?.testoMotivazione || '',
      idCertificato: impedimentoCurrent?.idCertificato || undefined,
      idImpedimento: impedimentoCurrent?.key?.idImpedimento || undefined,
      // castedNegoziazioneAssistita
      templateTranscriptionText:
        codiceSezione === CodeSection.DATI_TRASCRIZIONE_NEGOZ
          ? castedNegoziazioneAssistita?.trascrizioneAccordo || ''
          : undefined,
      dateStipulation: castedNegoziazioneAssistita?.dataStipulaAccordo
        ? DateTime.fromISO(castedNegoziazioneAssistita.dataStipulaAccordo)
        : null,
      depositDate:
        codiceSezione === CodeSection.DATI_PROVVEDIMENTO &&
        castedNegoziazioneAssistita?.dataDepositoProvvedimento
          ? DateTime.fromISO(castedNegoziazioneAssistita?.dataDepositoProvvedimento)
          : undefined,
      dateCommunication:
        codiceSezione === CodeSection.DATI_PROVVEDIMENTO &&
        castedNegoziazioneAssistita?.dataComunicazProvvedimento
          ? DateTime.fromISO(castedNegoziazioneAssistita?.dataComunicazProvvedimento)
          : undefined,
      // castedDatiIntegrativiTrascrizione
      idTemplateIcaro: Boolean(castedStatoCivile?.idIcaro)
        ? castedDatiIntegrativiTrascrizione?.codiceTemplate || ''
        : '',
      // disableTemplate: Boolean(castedStatoCivile?.idIcaro),
      // castedTrascrizioneSeparazioneAtti
      judgmentPublicationDate:
        codiceSezione === CodeSection.DATI_ATTO_TRASCRIZIONE &&
        castedTrascrizioneSeparazioneAtti?.dataPubblicazioneSentenza
          ? DateTime.fromISO(castedTrascrizioneSeparazioneAtti?.dataPubblicazioneSentenza)
          : undefined,
      effectiveDateSentence:
        codiceSezione === CodeSection.DATI_ATTO_TRASCRIZIONE &&
        castedTrascrizioneSeparazioneAtti?.dataDecorrenzaSentenza
          ? DateTime.fromISO(castedTrascrizioneSeparazioneAtti?.dataDecorrenzaSentenza)
          : undefined,
    };
  });

  return res;
};

const transformSectionDatiGeneraliRiconoscimento = (
  castedCertificatoSanitario?: CertificatoSanitario,
  castedDatiEventoRiconoscimento?: DatiEventoRiconoscimento,
  castedEvento?: Evento,
  castedConsenso?: Consenso,
  castedDatiAssenso?: DatiAssenso,
  riconoscimentoList?: Array<RiconoscimentoList>
): Record<string, SectionVM> => {
  const res: Record<string, SectionVM> = {};

  if (
    !Boolean(
      // castedCertificatoSanitario
      castedCertificatoSanitario?.autorita ||
        castedCertificatoSanitario?.dataRilascio ||
        castedCertificatoSanitario?.key?.idCertSanitario ||
        // castedDatiEventoRiconoscimento
        (castedDatiEventoRiconoscimento && castedDatiEventoRiconoscimento?.codiceSezione?.trim()) ||
        // castedEvento
        castedEvento?.flagSentenzaFiglioInc === '1' ||
        castedEvento?.codiceSezione === CodeSection.DATI_SPECIFICI_UNICIV
    )
  ) {
    return res;
  }

  if (
    castedEvento?.codiceSezione?.trim() === CodeSection.DATI_REGISTRO_EMERGENZA &&
    !Boolean(castedDatiEventoRiconoscimento?.codiceSezione?.trim())
  ) {
    return res;
  }

  const keyCurrent =
    castedDatiEventoRiconoscimento?.codiceSezione?.trim() || castedEvento?.codiceSezione?.trim();
  const keySection = `section-${keyCurrent}`;

  res[keySection] = {
    isSaved: true,
    // castedCertificatoSanitario
    certificateReleaseFrom: castedCertificatoSanitario?.autorita || '',
    certificateDate: castedCertificatoSanitario?.dataRilascio
      ? DateTime.fromISO(castedCertificatoSanitario.dataRilascio)
      : null,
    idCertSanitario: castedCertificatoSanitario?.key?.idCertSanitario || undefined,
    // castedDatiEventoRiconoscimento
    conceivedMonth: castedDatiEventoRiconoscimento?.mesiDalConcepimento?.toString() || '',
    idDatiEventoRiconoscimento:
      castedDatiEventoRiconoscimento?.key?.idDatiEventoRiconoscimento || undefined,
    typeDeclaration: castedDatiEventoRiconoscimento?.assenzaFiglio || undefined,
    consentReturnedBefore: castedDatiEventoRiconoscimento?.descrizioneAssensoReso || undefined,
    changeSurname: castedDatiEventoRiconoscimento?.sceltaCognome || undefined,
    dateCommunication: castedDatiEventoRiconoscimento?.dataComunicazione
      ? DateTime.fromISO(castedDatiEventoRiconoscimento?.dataComunicazione)
      : null,
    // castedConsenso
    idConsenso: castedConsenso?.key?.idConsenso || undefined,
    typologyConsent: castedConsenso?.tipoConsenso || undefined,
    // castedEvento
    isIncestuousSonSentence: castedEvento?.flagSentenzaFiglioInc === '1',
    presentationDocument:
      castedEvento?.tipoDatiProdotti || castedDatiEventoRiconoscimento?.datiProdotti || undefined,
    isWithInterprete:
      keyCurrent === CodeSection.DATI_SPECIFICI_MATR ||
      keyCurrent === CodeSection.DATI_SPECIFICI_UNICIV
        ? castedEvento?.flagAusilioInterprete === '1'
        : false,
    // castedDatiAssenso
    parentRecognition: castedDatiAssenso?.tipoAssenso || '',
    // riconoscimentoList
    riconoscimentoList: CodeSectionRiconsocimentoList.includes(keyCurrent as CodeSection)
      ? riconoscimentoList
      : undefined,
  };

  return res;
};

const transformTrascrizioneMorte = (
  castedTrascrizioneMorte?: TrascrizioneMorte,
  castedStatoCivile?: StatoCivile,
  castedDatiIntegrativiTrascrizione?: DatiIntegrativiTrascrizione
): Record<string, SectionVM> => {
  const res: Record<string, SectionVM> = {};

  if (!castedTrascrizioneMorte) {
    return res;
  }

  const keySection = `section-${castedTrascrizioneMorte?.codiceSezione?.trim()}`;

  res[keySection] = {
    isSaved: true,
    dateTranscription: castedTrascrizioneMorte.dataComunicazione
      ? DateTime.fromISO(castedTrascrizioneMorte.dataComunicazione)
      : null,
    templateTranscriptionText: castedTrascrizioneMorte.trascrizione || '',
    typeDisappearance: castedTrascrizioneMorte.tipoScomparsa || '',
    // castedDatiIntegrativiTrascrizione
    idTemplateIcaro: Boolean(castedStatoCivile?.idIcaro)
      ? castedDatiIntegrativiTrascrizione?.codiceTemplate || ''
      : '',
    // disableTemplate: Boolean(castedStatoCivile?.idIcaro),
  };

  return res;
};

const transformSectionTrascrizioneNascita = (
  castedTrascrizioneNascita?: TrascrizioneNascita,
  castedEvento?: Evento,
  castedEnteDichiaranteList?: Array<EnteDichiaranteList>,
  castedStatoCivile?: StatoCivile,
  castedDatiIntegrativiTrascrizione?: DatiIntegrativiTrascrizione,
  castedRichiedente?: Richiedente
): Record<string, SectionVM> => {
  const res: Record<string, SectionVM> = {};
  const filtredCastedEnteDichiaranteList =
    castedEnteDichiaranteList?.find((item) => item.sezione === CodeSection.DATI_TRASCRIZIONE) || {};

  if (!castedTrascrizioneNascita) {
    return res;
  }

  const key = castedTrascrizioneNascita?.codiceSezione?.trim() || '';
  const keySection = `section-${key}`;

  res[keySection] = {
    isSaved: true,
    // castedTrascrizioneNascita
    dateTranscription: castedTrascrizioneNascita.dataComunicazione
      ? DateTime.fromISO(castedTrascrizioneNascita.dataComunicazione)
      : null,
    dateChangeSurname: castedTrascrizioneNascita.dataProvvedCambioCognome
      ? DateTime.fromISO(castedTrascrizioneNascita.dataProvvedCambioCognome)
      : null,
    oldSurname: castedTrascrizioneNascita.vecchioCognomeGenitore || '',
    typeMutation: castedTrascrizioneNascita.cambioCognome || '',
    parentChangedSurname: castedTrascrizioneNascita.genitoreMutazioneCognome || '',
    measureExchangeSurname: castedTrascrizioneNascita.provvedCambioCognome || '',
    templateTranscriptionText: castedTrascrizioneNascita.trascrizione || '',
    typeRequest: castedTrascrizioneNascita.dichiarazione?.toString() || '',
    applicant: castedTrascrizioneNascita.richiedenteNascita
      ? {
          id: castedTrascrizioneNascita.richiedenteNascita,
          value: castedTrascrizioneNascita.descrizioneRichiedenteNascita || '',
        }
      : undefined,
    typeBirthPlace: castedTrascrizioneNascita.luogoNascita || '',
    descriptionBirthPlace: castedTrascrizioneNascita.specificaLuogoNascita || '',
    changeSurname: castedTrascrizioneNascita.sceltaCognome || '',
    newSurname: castedTrascrizioneNascita.nuovoCognome || '',
    newName: castedTrascrizioneNascita.nuovoNome || '',
    surnameAdded: castedTrascrizioneNascita.cognomeAggiunto || '',
    nameAdded: castedTrascrizioneNascita.nomeAggiunto || '',
    parentRecognition: castedTrascrizioneNascita.riconoscimentoNascita || '',
    sentenceRecognition:
      //key !== CodeSection.DATI_TRASCRIZIONE ?
      castedTrascrizioneNascita.riconoscimentoNascita || '',
    //: '',
    isPaternitySentence: castedTrascrizioneNascita.flagRiconPaternoConSentenza === '1',
    isSonUnknownParents: castedTrascrizioneNascita.flagFiglioDiIgnoti === '1',
    numberHolders: castedTrascrizioneNascita.numeroIntestatari?.toString(),
    numberChildren: castedTrascrizioneNascita.numeroFigli?.toString(),
    // castedRichiedente
    typeApplicant: castedRichiedente?.tipoRichiedente || '',
    // castedEvento
    presentationDocument: castedEvento?.tipoDatiProdotti || '',
    // castedEnteDichiaranteList
    nameInstituteAbandonedMinor: filtredCastedEnteDichiaranteList.nomeEnteDichiarante || '',
    idEnteDichiarante: filtredCastedEnteDichiaranteList.key?.idEnteDichiarante,
    // castedDatiIntegrativiTrascrizione
    templateTranscription: Boolean(castedStatoCivile?.idIcaro)
      ? castedDatiIntegrativiTrascrizione?.codiceTemplate || ''
      : '',
    idTemplateIcaro: Boolean(castedStatoCivile?.idIcaro)
      ? castedDatiIntegrativiTrascrizione?.codiceTemplate || ''
      : '',
    // disableTemplate: Boolean(castedStatoCivile?.idIcaro),
  };

  return res;
};

const transformSectionTrascrizioneNascitaFiglioDiIgnoti = (
  castedTrascrizioneNascita?: TrascrizioneNascita
): Record<string, SectionVM> => {
  const res: Record<string, SectionVM> = {};
  if (!castedTrascrizioneNascita || !castedTrascrizioneNascita?.flagFiglioDiIgnoti) {
    return res;
  }

  const keySection = `section-${CodeSection.TRASCRIZIONE_NASCITA}`;

  res[keySection] = {
    isSaved: true,
    isSonUnknownParents: castedTrascrizioneNascita?.flagFiglioDiIgnoti === '1',
  };

  return res;
};

const transformSectionTrascrizioneCittadinanza = (
  castedTrascrizioneCittadinanza?: TrascrizioneCittadinanza,
  castedStatoCivile?: StatoCivile,
  castedDatiIntegrativiTrascrizione?: DatiIntegrativiTrascrizione
): Record<string, SectionVM> => {
  const res: Record<string, SectionVM> = {};

  if (!castedTrascrizioneCittadinanza) {
    return res;
  }

  const keySection = `section-${castedTrascrizioneCittadinanza?.codiceSezione?.trim()}`;

  res[keySection] = {
    isSaved: true,
    dateTranscription: castedTrascrizioneCittadinanza.dataComunicazione
      ? DateTime.fromISO(castedTrascrizioneCittadinanza.dataComunicazione)
      : null,
    dateMarriage: castedTrascrizioneCittadinanza.dataMatrimonio
      ? DateTime.fromISO(castedTrascrizioneCittadinanza.dataMatrimonio)
      : null,
    templateTranscriptionText: castedTrascrizioneCittadinanza.trascrizione || '',
    parentTransmittedCitizenship: castedTrascrizioneCittadinanza?.genitoreConCittadinanza || '',
    // parentRecognition: castedTrascrizioneCittadinanza?.genitoreConCittadinanza || '',
    dateOutcomeVerification: castedTrascrizioneCittadinanza?.dataAccertamento
      ? DateTime.fromISO(castedTrascrizioneCittadinanza?.dataAccertamento)
      : null,
    assessmentResult: castedTrascrizioneCittadinanza?.esitoAccertamento || '',
    dateMeasureMayor: castedTrascrizioneCittadinanza?.dataProvvedimentoSindaco
      ? DateTime.fromISO(castedTrascrizioneCittadinanza?.dataProvvedimentoSindaco)
      : null,
    dateEffectiveMeasure: castedTrascrizioneCittadinanza?.dataEfficaciaProvvedEstero
      ? DateTime.fromISO(castedTrascrizioneCittadinanza?.dataEfficaciaProvvedEstero)
      : null,
    protocolNumber: castedTrascrizioneCittadinanza?.protocollo || '',
    typeRequest: castedTrascrizioneCittadinanza?.dichiarazione?.toString() || '',
    // castedDatiIntegrativiTrascrizione
    idTemplateIcaro: Boolean(castedStatoCivile?.idIcaro)
      ? castedDatiIntegrativiTrascrizione?.codiceTemplate || ''
      : '',
    // disableTemplate: Boolean(castedStatoCivile?.idIcaro),
  };

  return res;
};

const transformSectionReceivedByPostTrascrizioneCittadinanza = (
  castedTrascrizioneCittadinanza?: TrascrizioneCittadinanza
): Record<string, SectionVM> => {
  const res: Record<string, SectionVM> = {};

  if (!castedTrascrizioneCittadinanza?.flagRichiestaPerPosta) {
    return res;
  }

  const keySection = `section-${CodeSection.TRASCRIZIONE_CITTADINANZA}`;

  res[keySection] = {
    isSaved: true,
    isReceivedByPost: castedTrascrizioneCittadinanza.flagRichiestaPerPosta === '1',
  };

  return res;
};

const transformDatiEventoCittadinanza = (
  castedDatiEventoCittadinanza?: DatiEventoCittadinanza,
  castedEvento?: Evento,
  castedTrascrizioneCittadinanza?: TrascrizioneCittadinanza,
  castedStatoCivile?: StatoCivile,
  castedDatiIntegrativiTrascrizione?: DatiIntegrativiTrascrizione,
  castedTrascrizioneNascita?: TrascrizioneNascita
): Record<string, SectionVM> => {
  const res: Record<string, SectionVM> = {};

  if (!castedDatiEventoCittadinanza) {
    return res;
  }

  const keySection = `section-${castedDatiEventoCittadinanza?.codiceSezione?.trim()}`;

  const isOtherMunicipality =
    castedDatiEventoCittadinanza?.comuneResidenza?.toString() === ID_ALTRO_COMUNE;

  res[keySection] = {
    isSaved: true,
    // castedDatiEventoCittadinanza
    requestProtocol: castedDatiEventoCittadinanza?.protocollo || '',
    dateReport: castedDatiEventoCittadinanza?.dataVerbale
      ? DateTime.fromISO(castedDatiEventoCittadinanza?.dataVerbale)
      : null,
    reasonLossCitizenship: castedDatiEventoCittadinanza?.testoMotivoPerditaCittadinanza || '',
    typeResidence: castedDatiEventoCittadinanza?.residenza || '',
    italian: castedDatiEventoCittadinanza?.nomeComuneResidenza
      ? {
          municipality: {
            description: isOtherMunicipality
              ? LABEL_ALTRO_COMUNE
              : castedDatiEventoCittadinanza?.nomeComuneResidenza || '',
            id: castedDatiEventoCittadinanza?.comuneResidenza?.toString() || '',
            province: castedDatiEventoCittadinanza?.siglaProvResidenza || '',
            provinceCode: castedDatiEventoCittadinanza?.provinciaResidenza?.toString() || '',
          },
          otherMunicipality: isOtherMunicipality
            ? castedDatiEventoCittadinanza?.nomeComuneResidenza
            : '',
        }
      : undefined,
    typeService: castedDatiEventoCittadinanza.impiego || '',
    nationEmployment: castedDatiEventoCittadinanza.nazioneImpiego
      ? ({
          id: castedDatiEventoCittadinanza.nazioneImpiego || '',
          value: castedDatiEventoCittadinanza.nomeNazioneImpiego || '',
          code: castedDatiEventoCittadinanza.nazioneImpiego || '',
        } as ForeignStateVM)
      : undefined,
    dateRegistrationCourt: castedDatiEventoCittadinanza.dataRegistrazioneDecreto
      ? DateTime.fromISO(castedDatiEventoCittadinanza.dataRegistrazioneDecreto)
      : null,
    parentCitizenship: castedDatiEventoCittadinanza.eventoCittadinanza || undefined,
    dateConferralDecree: castedDatiEventoCittadinanza.dataDecretoConferimento
      ? DateTime.fromISO(castedDatiEventoCittadinanza.dataDecretoConferimento)
      : null,
    dateNotificationDecree: castedDatiEventoCittadinanza.dataNotificaDecreto
      ? DateTime.fromISO(castedDatiEventoCittadinanza.dataNotificaDecreto)
      : null,
    extremesDecree: castedDatiEventoCittadinanza.estremiDecretoConf || '',
    summaryStatement: castedDatiEventoCittadinanza.riassuntoDichiarazione || '',
    templateTranscriptionText: castedDatiEventoCittadinanza?.infoResidenzaBiennale || '',
    authorityPostAddress: castedDatiEventoCittadinanza.indirizzoAutorita || '',
    dateOath: castedDatiEventoCittadinanza.dataGiuramento
      ? DateTime.fromISO(castedDatiEventoCittadinanza.dataGiuramento)
      : null,
    extremesOath: castedDatiEventoCittadinanza?.estremiGiuramento || '',
    // castedEvento
    presentationDocument: castedEvento?.tipoDatiProdotti || '',
    sentenceRecognition:
      castedEvento?.riconoscimentoSentenza ||
      castedTrascrizioneNascita?.riconoscimentoNascita ||
      '',
    // castedTrascrizioneCittadinanza
    parentRecognition:
      castedDatiEventoCittadinanza?.codiceSezione?.trim() === CodeSection.RIC_GENITORE_ITALIANO
        ? castedTrascrizioneCittadinanza?.genitoreConCittadinanza || ''
        : '',
    typeRequest:
      castedDatiEventoCittadinanza?.codiceSezione?.trim() === CodeSection.DATI_EVENTO_CITTADINANZA
        ? castedTrascrizioneCittadinanza?.dichiarazione || ''
        : '',
    dateTranscription:
      castedDatiEventoCittadinanza?.codiceSezione?.trim() === CodeSection.DATI_EVENTO_CITTADINANZA
        ? castedTrascrizioneCittadinanza?.dataComunicazione
          ? DateTime.fromISO(castedTrascrizioneCittadinanza?.dataComunicazione)
          : null
        : null,
    // castedStatoCivile
    isResidencePresentationDocuments: castedStatoCivile?.flagResidenzaDaAltraDoc === '1',
    typeExtremesDecree: castedStatoCivile?.codiceTempisticaGiuramento || '',
    extremesPec: castedStatoCivile?.numeroPecRiammissione || '',
    // castedDatiIntegrativiTrascrizione
    idTemplateIcaro: Boolean(castedStatoCivile?.idIcaro)
      ? castedDatiIntegrativiTrascrizione?.codiceTemplate || ''
      : '',
    // disableTemplate: Boolean(castedStatoCivile?.idIcaro),
  };

  return res;
};

const transformAttoCollegatoList = (
  castedAttoCollegatoList?: Array<AttoCollegato>,
  castedConsenso?: Consenso,
  riconoscimentoList?: Array<RiconoscimentoList>,
  castedStatoCivile?: StatoCivile
): Record<string, SectionVM> => {
  const res: Record<string, SectionVM> = {};

  if ((castedAttoCollegatoList || []).length === 0) {
    return res;
  }

  castedAttoCollegatoList?.forEach((castedAttoCollegato) => {
    const key = castedAttoCollegato?.sezione?.trim();
    const keySection = `section-${key}`;

    const isAttoDiConsensoAtcoP = key === CodeSection.ATTO_DI_CONSENSO_ATCOP;
    const isAttoDaRettificare = key === CodeSection.ATTO_DA_RETTIFICARE;

    const isOtherMunicipality =
      castedAttoCollegato.idComuneRegistrazione?.toString() === ID_ALTRO_COMUNE;

    res[keySection] = {
      isSaved: true,
      // castedConsenso
      idConsenso: isAttoDiConsensoAtcoP ? castedConsenso?.key?.idConsenso : undefined,
      presentationDocument: isAttoDiConsensoAtcoP ? castedConsenso?.datiProdotti || '' : '',
      // castedAttoCollegato
      idAttoCollegato: castedAttoCollegato?.key?.idAttoCollegato || undefined,
      typeAct: castedAttoCollegato?.tipoAttoPresentato || CodeTypeAct.attoCartaceo,
      actForm: {
        idAnsc: castedAttoCollegato.idAnsc || '',
        idEventoCollegato: isAttoDaRettificare
          ? castedStatoCivile?.idEventoCorrelato?.toString() || ''
          : '',
        typeEvent: castedAttoCollegato.tipoContenuto || '',
        municipalNumber: castedAttoCollegato.numeroAtto?.toString() || '',
        year: castedAttoCollegato.annoAtto?.toString() || '',
        register: castedAttoCollegato.tipologiaAtto || '',
        portion: castedAttoCollegato.parteAtto || '',
        serie: castedAttoCollegato.serieAtto || '',
        volume: castedAttoCollegato.volumeAtto || '',
        dateAct: castedAttoCollegato.dataFormazioneAtto
          ? DateTime.fromISO(castedAttoCollegato.dataFormazioneAtto)
          : null,
        italian: {
          municipality: castedAttoCollegato.nomeComuneRegistrazione
            ? {
                description: isOtherMunicipality
                  ? LABEL_ALTRO_COMUNE
                  : castedAttoCollegato.nomeComuneRegistrazione || '',
                code: castedAttoCollegato.idComuneRegistrazione,
                id: castedAttoCollegato.idComuneRegistrazione?.toString() || '',
                province: castedAttoCollegato.siglaProvRegistrazione || '',
                provinceCode: castedAttoCollegato.idProvRegistrazione?.toString() || '',
                idProvince: castedAttoCollegato.idProvRegistrazione,
              }
            : undefined,
          otherMunicipality: isOtherMunicipality ? castedAttoCollegato.nomeComuneRegistrazione : '',
        },
      },
      // riconoscimentoList
      riconoscimentoList: CodeSectionRiconsocimentoList.includes(key as CodeSection)
        ? riconoscimentoList
        : undefined,
    };
  });

  return res;
};

const transformEventoSection = (
  castedEvento?: Evento,
  castedStatoCivile?: StatoCivile
): Record<string, SectionVM> => {
  const res: Record<string, SectionVM> = {};

  if (
    castedEvento?.codiceSezione?.trim() !== CodeSection.DATI_GENERALI &&
    castedEvento?.codiceSezione?.trim() !== CodeSection.DATI_GEN &&
    castedEvento?.codiceSezione?.trim() !== CodeSection.DATI_GENERALI_PRES_DOC_EVENTO &&
    castedEvento?.codiceSezione?.trim() !== CodeSection.DATI_GENERALI_CONS_RICO_EVENTO &&
    castedEvento?.codiceSezione?.trim() !== CodeSection.DATI_REGISTRO_EMERGENZA
  ) {
    return res;
  }

  const keySection = `section-${castedEvento?.codiceSezione?.trim()}`;

  res[keySection] = {
    isSaved: true,
    descriptionsReasonRecovery: castedEvento?.descrizioneMotivoRecupero || '',
    reasonRecovery: castedEvento?.motivoRecupero || '',
    effectiveDate: castedEvento?.timestampDecorrenza
      ? DateTime.fromISO(castedEvento?.timestampDecorrenza as string)
      : null,
    effectiveTime: castedEvento?.timestampDecorrenza
      ? DateTime.fromISO(castedEvento?.timestampDecorrenza as string)
      : null,
    presentationDocument: castedEvento.tipoDatiProdotti || '',
    isAbstractForSummary: castedEvento.flagEstrattoPerRiassunto === '1',
    isSimpleCertificate: castedEvento.flagCertificatoSemplice === '1',
    identifier: castedEvento.idAttoCartaceo || '',
    emergencyRegister: castedStatoCivile?.idRdE
      ? {
          id: castedStatoCivile?.idRdE,
          value: castedStatoCivile.descRdE || '',
        }
      : undefined,
    margin: castedStatoCivile?.codMargineRdE || '',
    number: castedStatoCivile?.numeroAttoRdE || '',
  };

  return res;
};

const transformComposizioneSection = (
  castedComposizione?: Composizione,
  castedEvento?: Evento,
  castedMatrimonioAtti?: MatrimonioAtti,
  castedUnioneCivileAtti?: UnioneCivileAtti
): Record<string, SectionVM> => {
  const res: Record<string, SectionVM> = {};

  if (
    !(
      castedComposizione ||
      castedMatrimonioAtti?.testoDelega ||
      castedUnioneCivileAtti?.testoDelega
    )
  ) {
    return res;
  }

  const key = castedComposizione
    ? castedComposizione?.codiceSezione?.trim()
    : castedMatrimonioAtti?.testoDelega
    ? CodeSection.TESTO_DELEGA_MATRIMONIO
    : castedUnioneCivileAtti?.testoDelega
    ? CodeSection.TESTO_DELEGA_UNIONE_CIVILE
    : '';
  const keySection = `section-${key}`;

  res[keySection] = {
    isSaved: true,
    isNotCertifiable: castedEvento?.flagAnnotazNonCertificabile === '1',
    actComposition:
      castedComposizione?.composizioneCompleta ||
      castedMatrimonioAtti?.testoDelega ||
      castedUnioneCivileAtti?.testoDelega ||
      '',
  };

  return res;
};

const transformConsensoSection = (
  castedConsenso?: Consenso,
  castedEvento?: Evento,
  castedDatiEventoRiconoscimento?: DatiEventoRiconoscimento
): Record<string, SectionVM> => {
  const res: Record<string, SectionVM> = {};

  const key = castedConsenso?.codiceSezione?.trim();

  if (!castedConsenso || key === CodeSection.DATI_GENERALI_CONS_ASS_COGNRID_RICO) {
    return res;
  }

  const keySection = `section-${key}`;

  res[keySection] = {
    isSaved: true,
    // castedConsenso
    idConsenso: castedConsenso?.key?.idConsenso || undefined,
    reasonLackConsent: castedConsenso?.mancatoConsenso || undefined,
    typologyConsent: castedConsenso?.tipoConsenso || undefined,
    // castedDatiEventoRiconoscimento
    typeDeclaration: castedDatiEventoRiconoscimento?.assenzaFiglio || undefined,
    idDatiEventoRiconoscimento:
      castedDatiEventoRiconoscimento?.key?.idDatiEventoRiconoscimento || undefined,
    // castedEvento
    presentationDocument: castedEvento?.tipoDatiProdotti || undefined,
    isIncestuousSonSentence: castedEvento?.flagSentenzaFiglioInc === '1',
  };

  return res;
};

const transformLuogoSection = (
  castedLuogo?: Luogo,
  castedTrascrizioneMorte?: TrascrizioneMorte
): Record<string, SectionVM> => {
  const res: Record<string, SectionVM> = {};

  if (
    !castedLuogo ||
    castedLuogo.codiceSezione === CodeSection.DATI_SPECIFICI_UNICIV ||
    castedLuogo.codiceSezione === CodeSection.DATI_SPECIFICI_MATR
  ) {
    return res;
  }

  const keySection = `section-${castedLuogo.codiceSezione?.trim()}`;

  const isOtherState = castedLuogo?.idStato?.toString() === ID_ALTRO_STATO;
  const isOtherMunicipality = castedLuogo?.idComune?.toString() === ID_ALTRO_COMUNE;

  res[keySection] = {
    isSaved: true,
    // castedLuogo
    idLuogo: castedLuogo.key?.idLuogo || undefined,
    isForeign: castedLuogo?.idStato !== ID_ITALIAN_NATION,
    foreign:
      castedLuogo?.idStato && castedLuogo?.idStato !== ID_ITALIAN_NATION
        ? {
            state: {
              id: castedLuogo?.idStato?.toString() || '',
              value: isOtherState ? LABEL_ALTRO_STATO : castedLuogo?.nomeStato || '',
              code: castedLuogo?.idStato?.toString() || '',
            },
            otherState: isOtherState ? castedLuogo?.nomeStato : '',
          }
        : undefined,
    italian: castedLuogo?.idComune
      ? {
          municipality: {
            id: castedLuogo?.idComune?.toString(),
            code: castedLuogo?.idComune,
            description: isOtherMunicipality ? LABEL_ALTRO_COMUNE : castedLuogo?.nomeComune || '',
            idProvince: castedLuogo?.idProvincia || undefined,
            province: castedLuogo?.siglaProvincia || '',
          },
          otherMunicipality: isOtherMunicipality ? castedLuogo?.nomeComune : '',
        }
      : undefined,
    // castedTrascrizioneMorte
    dateLastSighting: castedTrascrizioneMorte?.dataUltimoAvvistamento
      ? DateTime.fromISO(castedTrascrizioneMorte?.dataUltimoAvvistamento)
      : null,
  };

  return res;
};

export const transformDatiAnnotazioneList = (
  castedDatiAnnotazioneList?: Array<DatiAnnotazioneList>
): Record<string, SectionVM> => {
  const res: Record<string, SectionVM> = {};

  if ((castedDatiAnnotazioneList || [])?.length === 0) {
    return res;
  }

  const keySection = KeySections.keyAnnotazioneContestuale;

  res[keySection] = {
    isSaved: true,
    // castedDatiAnnotazioneList
    annotations: castedDatiAnnotazioneList?.map((itemAnnotation) => ({
      disabled:
        itemAnnotation.tipoAnnotazione === IdPropertyRegime.ConvenzioniMatrimoniali ||
        itemAnnotation.tipoAnnotazione === IdPropertyRegime.SeparazioneDeiBeni ||
        itemAnnotation.tipoAnnotazione === IdPropertyRegime.AltraLeggeApplicabile,
      idAnnotazione: itemAnnotation.key?.idDatiAnnotazione,
      isNotCertifiable: itemAnnotation.flagAnnotazioneNonCert === '1',
      typeContextualAnnotation: itemAnnotation.tipoAnnotazione || '',
      textContextualAnnotation: itemAnnotation.annotazione || '',
      dateInsertion: itemAnnotation.timestampInserimento
        ? DateTime.fromISO(itemAnnotation.timestampInserimento).toFormat('dd/MM/yyyy')
        : '',
    })),
  };

  return res;
};

const transformUnioneCivileAtti = (
  castedUnioneCivileAtti?: UnioneCivileAtti,
  castedEvento?: Evento,
  castedLuogo?: Luogo,
  castedDatiIntegrativiTrascrizione?: DatiIntegrativiTrascrizione
): Record<string, SectionVM> => {
  const res: Record<string, SectionVM> = {};

  if (!castedUnioneCivileAtti) {
    return res;
  }

  const key = castedUnioneCivileAtti.codiceSezione?.trim();
  const keySection = `section-${key}`;

  const dataLuogo = castedLuogo?.codiceSezione === key ? castedLuogo : {};

  const isOtherState = dataLuogo?.idStato?.toString() === ID_ALTRO_STATO;
  const isOtherMunicipality = dataLuogo?.idComune?.toString() === ID_ALTRO_COMUNE;
  const isOtherMunicipalityDelegating =
    castedUnioneCivileAtti?.idComuneDelegante?.toString() === ID_ALTRO_COMUNE;

  res[keySection] = {
    isSaved: true,
    // castedUnioneCivileAtti
    dataCivilUnion:
      key === CodeSection.DATI_UNIONE_CIVILE && castedUnioneCivileAtti.dataEvento
        ? DateTime.fromISO(castedUnioneCivileAtti.dataEvento)
        : null,
    dateEvent:
      key !== CodeSection.DATI_UNIONE_CIVILE && castedUnioneCivileAtti.dataEvento
        ? DateTime.fromISO(castedUnioneCivileAtti.dataEvento)
        : null,
    timeEvent:
      castedUnioneCivileAtti?.oraEvento?.toString() ||
      castedUnioneCivileAtti?.minutoEvento?.toString()
        ? DateTime.fromFormat(
            `${
              castedUnioneCivileAtti.oraEvento?.toString().length === 1
                ? `0${castedUnioneCivileAtti.oraEvento}`
                : castedUnioneCivileAtti.oraEvento || '00'
            }:${
              castedUnioneCivileAtti.minutoEvento?.toString().length === 1
                ? `0${castedUnioneCivileAtti.minutoEvento}`
                : castedUnioneCivileAtti.minutoEvento || '00'
            }`,
            'HH:mm'
          )
        : null,
    numberWitnesses: castedUnioneCivileAtti.numeroTestimoni?.toString(),
    opposition:
      castedUnioneCivileAtti.flagRigettoOpposizione === '1'
        ? ID_OPPOSITION.ID_DECRETO
        : castedUnioneCivileAtti.flagEstintaOpposizione === '1'
        ? ID_OPPOSITION.ID_PROVVEDIMENTO
        : ID_OPPOSITION.ID_NESSUNA,
    genericImpediment: castedUnioneCivileAtti.tipoImpedimentoGenerico || '',
    impedimentUnitedCivilly: castedUnioneCivileAtti.tipoSoggettoConImpedimento || '',
    dataDelegate: castedUnioneCivileAtti.dataDelega
      ? DateTime.fromISO(castedUnioneCivileAtti.dataDelega)
      : null,
    textDelegate: castedUnioneCivileAtti.testoDelega || '',
    isForeignDelegating: !Boolean(castedUnioneCivileAtti?.idComuneDelegante),
    italianDelegating: castedUnioneCivileAtti?.idComuneDelegante
      ? {
          municipality: {
            id: castedUnioneCivileAtti?.idComuneDelegante?.toString(),
            code: castedUnioneCivileAtti?.idComuneDelegante,
            description: isOtherMunicipalityDelegating
              ? LABEL_ALTRO_COMUNE
              : castedUnioneCivileAtti?.nomeComuneDelegante || '',
            idProvince: castedUnioneCivileAtti?.idProvinciaDelegante || undefined,
            province: castedUnioneCivileAtti?.siglaProvinciaDelegante || '',
          },
          otherMunicipality: isOtherMunicipalityDelegating
            ? castedUnioneCivileAtti?.nomeComuneDelegante
            : '',
        }
      : undefined,
    foreignDelegating: castedUnioneCivileAtti?.idConsolatoDelegante
      ? {
          state: {
            id: castedUnioneCivileAtti?.idNazioneDelegante?.toString() || '',
            value: isOtherState
              ? LABEL_ALTRO_STATO
              : castedUnioneCivileAtti?.nomeNazioneDelegante || '',
            code: castedUnioneCivileAtti?.idNazioneDelegante?.toString(),
          },
          otherState: isOtherState ? castedUnioneCivileAtti?.nomeNazioneDelegante : '',
          consulate: castedUnioneCivileAtti?.idConsolatoDelegante
            ? {
                id: castedUnioneCivileAtti?.idConsolatoDelegante,
                value: castedUnioneCivileAtti?.nomeConsolatoDelegante || '',
              }
            : undefined,
        }
      : undefined,
    // castedEvento
    presentationDocument: castedEvento?.tipoDatiProdotti || '',
    isWithInterprete:
      castedEvento?.codiceSezione === CodeSection.DATI_SPECIFICI_UNICIV
        ? castedEvento.flagAusilioInterprete === '1'
        : false,
    // dataLuogo
    idLuogo: dataLuogo?.key?.idLuogo || undefined,
    isForeign: dataLuogo?.idStato !== ID_ITALIAN_NATION,
    foreign:
      dataLuogo?.idStato && dataLuogo?.idStato !== ID_ITALIAN_NATION
        ? {
            state: {
              id: dataLuogo?.idStato?.toString() || '',
              value: isOtherState ? LABEL_ALTRO_STATO : dataLuogo?.nomeStato || '',
              code: dataLuogo?.idStato?.toString() || '',
            },
            otherState: isOtherState ? dataLuogo?.nomeStato : '',
            locationForeign: dataLuogo?.nomeComuneEstero || '',
          }
        : undefined,
    italian: dataLuogo?.idComune
      ? {
          municipality: {
            id: dataLuogo?.idComune?.toString(),
            code: dataLuogo?.idComune,
            description: isOtherMunicipality ? LABEL_ALTRO_COMUNE : dataLuogo?.nomeComune || '',
            idProvince: dataLuogo?.idProvincia || undefined,
            province: dataLuogo?.siglaProvincia || '',
          },
          otherMunicipality: isOtherMunicipality ? dataLuogo?.nomeComune : '',
        }
      : undefined,
    address: dataLuogo?.indirizzo || '',
    place: dataLuogo?.luogo || '',
    houseNumber: dataLuogo?.civico || '',
    // castedTrascrizioneSeparazioneAtti
    ufcDelegate: castedDatiIntegrativiTrascrizione?.descrizioneUfficialeDelegante || '',
    reason: castedDatiIntegrativiTrascrizione?.motivoDelega || '',
  };

  return res;
};

const transformCertificatoUnioneCivileList = (
  castedCertificatoUnioneCivileList?: Array<CertificatoUnioneCivileList>
): Record<string, SectionVM> => {
  const res: Record<string, SectionVM> = {};

  if ((castedCertificatoUnioneCivileList || [])?.length === 0) {
    return res;
  }

  castedCertificatoUnioneCivileList?.forEach((itemSection) => {
    const keySection = `section-${itemSection.codiceSezione?.trim()}`;

    const isOtherMunicipality = itemSection?.idComune?.toString() === ID_ALTRO_COMUNE;

    res[keySection] = {
      isSaved: true,
      idCertificatoUnioneCivile: itemSection.key?.idCertificatoUnioneCivile || undefined,
      dateIncorporationCertificate: itemSection.dataRichiestaCostituzione
        ? DateTime.fromISO(itemSection.dataRichiestaCostituzione)
        : null,
      italian: itemSection?.idComune
        ? {
            municipality: {
              id: itemSection?.idComune?.toString(),
              code: itemSection?.idComune,
              description: isOtherMunicipality ? LABEL_ALTRO_COMUNE : itemSection?.nomeComune || '',
              idProvince: itemSection?.idProvincia || undefined,
              province: itemSection?.siglaProvincia || '',
            },
            otherMunicipality: isOtherMunicipality ? itemSection?.nomeComune : '',
          }
        : undefined,
    };
  });

  return res;
};

const transformRegimePatrimoniale = (
  castedRegimePatrimoniale?: RegimePatrimoniale,
  castedDatiAnnotazioneList?: Array<DatiAnnotazioneList>
): Record<string, SectionVM> => {
  const res: Record<string, SectionVM> = {};

  if (!castedRegimePatrimoniale) {
    return res;
  }

  const keySection = `section-${castedRegimePatrimoniale.codiceSezione?.trim()}`;

  const dataAnnotazione: DatiAnnotazioneList | undefined = (castedDatiAnnotazioneList || []).find(
    (item) =>
      item.tipoAnnotazione === IdPropertyRegime.ConvenzioniMatrimoniali ||
      item.tipoAnnotazione === IdPropertyRegime.SeparazioneDeiBeni ||
      item.tipoAnnotazione === IdPropertyRegime.AltraLeggeApplicabile
  );

  res[keySection] = {
    isSaved: true,
    // castedRegimePatrimoniale
    idRegimePatrimoniale: castedRegimePatrimoniale.key?.idRegimePatrimoniale || null,
    propertyRegime: castedRegimePatrimoniale.tipoRegimePatrimoniale || '',
    lawPropertyRegime: castedRegimePatrimoniale.numeroLegge || '',
    isWithNotarialDeed: castedRegimePatrimoniale.flagConAttoNotarile === '1',
    surnameNotary: castedRegimePatrimoniale.descrizioneCognomeNotaio || '',
    nameNotary: castedRegimePatrimoniale.descrizioneNomeNotaio || '',
    notarialDistrict: castedRegimePatrimoniale.nomeDistrettoNotarile || '',
    datePropertyRegime: castedRegimePatrimoniale.dataAttoNotarile
      ? DateTime.fromISO(castedRegimePatrimoniale.dataAttoNotarile)
      : null,
    repertoireNumber: castedRegimePatrimoniale.numeroRepertorio || '',
    collectionNumber: castedRegimePatrimoniale.numeroRaccolta || '',
    // dataAnnotazione
    annotationsPropertyRegime: dataAnnotazione
      ? {
          idAnnotazione: dataAnnotazione.key?.idDatiAnnotazione,
          isNotCertifiable: dataAnnotazione.flagAnnotazioneNonCert === '1',
          typeContextualAnnotation: dataAnnotazione.tipoAnnotazione || '',
          textContextualAnnotation: dataAnnotazione.annotazione || '',
          dateInsertion: dataAnnotazione.timestampInserimento
            ? DateTime.fromISO(dataAnnotazione.timestampInserimento).toFormat('dd/MM/yyyy')
            : '',
        }
      : undefined,
  };

  return res;
};

const transformMatrimonioAtti = (
  castedMatrimonioAtti?: MatrimonioAtti,
  castedEvento?: Evento,
  castedLuogo?: Luogo,
  castedRegimePatrimoniale?: RegimePatrimoniale,
  castedDatiEventoRiconoscimento?: DatiEventoRiconoscimento,
  castedConsenso?: Consenso,
  castedStatoCivile?: StatoCivile,
  castedDatiIntegrativiTrascrizione?: DatiIntegrativiTrascrizione
): Record<string, SectionVM> => {
  const res: Record<string, SectionVM> = {};

  if (!castedMatrimonioAtti) {
    return res;
  }

  const key = castedMatrimonioAtti.codiceSezione?.trim();
  const keySection = `section-${key}`;

  const dataLuogo = castedLuogo?.codiceSezione === key ? castedLuogo : {};

  const isOtherState = dataLuogo?.idStato?.toString() === ID_ALTRO_STATO;
  const isOtherMunicipality = dataLuogo?.idComune?.toString() === ID_ALTRO_COMUNE;
  const isOtherMunicipalityDelegating = dataLuogo?.idComune?.toString() === ID_ALTRO_COMUNE;

  res[keySection] = {
    isSaved: true,
    // castedMatrimonioAtti
    dateEvent: castedMatrimonioAtti.dataEvento
      ? DateTime.fromISO(castedMatrimonioAtti.dataEvento)
      : null,
    timeEvent:
      castedMatrimonioAtti?.oraEvento?.toString() || castedMatrimonioAtti?.minutoEvento?.toString()
        ? DateTime.fromFormat(
            `${
              castedMatrimonioAtti.oraEvento?.toString().length === 1
                ? `0${castedMatrimonioAtti.oraEvento}`
                : castedMatrimonioAtti.oraEvento || '00'
            }:${
              castedMatrimonioAtti.minutoEvento?.toString().length === 1
                ? `0${castedMatrimonioAtti.minutoEvento}`
                : castedMatrimonioAtti.minutoEvento || '00'
            }`,
            'HH:mm'
          )
        : null,
    numberWitnesses: castedMatrimonioAtti.numeroTestimoni?.toString(),
    opposition:
      castedMatrimonioAtti.flagRigettoOpposizione === '1'
        ? ID_OPPOSITION.ID_DECRETO
        : castedMatrimonioAtti.flagEstintaOpposizione === '1'
        ? ID_OPPOSITION.ID_PROVVEDIMENTO
        : ID_OPPOSITION.ID_NESSUNA,
    ageDefect: castedMatrimonioAtti.tipoDifettoEta || '',
    relationship: castedMatrimonioAtti.tipoImpedimentoParentela || '',
    isTemporaryBanRemarriage: castedMatrimonioAtti.flagDivietoTemporaneo === '1',
    publication:
      castedMatrimonioAtti.flagPiuPubblicazioni === '1'
        ? ID_PUBBLICATIONS.ID_PUBBLICATION_OCCURRED
        : castedMatrimonioAtti.flagOmissionePubblicazione === '1'
        ? ID_PUBBLICATIONS.ID_PUBBLICATION_OMISSION
        : ID_PUBBLICATIONS.ID_PUBBLICATION_SINGLE,
    minorGroomAssistance: castedMatrimonioAtti.tipoAssistenteSposo || '',
    minorWifeAssistance: castedMatrimonioAtti.tipoAssistenteSposa || '',
    dataDelegate: castedMatrimonioAtti.dataDelega
      ? DateTime.fromISO(castedMatrimonioAtti.dataDelega)
      : null,
    textDelegate: castedMatrimonioAtti.testoDelega || '',
    isForeignDelegating: !Boolean(castedMatrimonioAtti.idComuneDelegante),
    italianDelegating: castedMatrimonioAtti?.idComuneDelegante
      ? {
          municipality: {
            id: castedMatrimonioAtti?.idComuneDelegante?.toString(),
            code: castedMatrimonioAtti?.idComuneDelegante,
            description: isOtherMunicipalityDelegating
              ? LABEL_ALTRO_COMUNE
              : castedMatrimonioAtti?.nomeComuneDelegante || '',
            idProvince: castedMatrimonioAtti?.idProvinciaDelegante || undefined,
            province: castedMatrimonioAtti?.siglaProvinciaDelegante || '',
          },
          otherMunicipality: isOtherMunicipalityDelegating
            ? castedMatrimonioAtti?.nomeComuneDelegante
            : '',
        }
      : undefined,
    foreignDelegating: castedMatrimonioAtti?.idConsolatoDelegante
      ? {
          state: {
            id: castedMatrimonioAtti?.idNazioneDelegante?.toString() || '',
            value: isOtherState
              ? LABEL_ALTRO_STATO
              : castedMatrimonioAtti?.nomeNazioneDelegante || '',
            code: castedMatrimonioAtti?.idNazioneDelegante?.toString(),
          },
          otherState: isOtherState ? castedMatrimonioAtti?.nomeNazioneDelegante : '',
          consulate: castedMatrimonioAtti?.idConsolatoDelegante
            ? {
                id: castedMatrimonioAtti?.idConsolatoDelegante,
                value: castedMatrimonioAtti?.nomeConsolatoDelegante || '',
              }
            : undefined,
        }
      : undefined,
    impedimentUnitedCivilly: castedMatrimonioAtti?.tipoSoggettoConImpedimento || '',
    ritualReligious: castedStatoCivile?.codiceRito
      ? {
          id: castedStatoCivile?.codiceRito,
          value: castedMatrimonioAtti?.descrizioneRitoReligioso || '',
        }
      : undefined,
    otherRitualReligious:
      !castedMatrimonioAtti?.descrizioneRitoReligioso ||
      Number.parseInt(castedMatrimonioAtti?.descrizioneRitoReligioso || '', 10)
        ? ''
        : castedMatrimonioAtti?.descrizioneRitoReligioso,
    declarant: castedMatrimonioAtti.tipoDichiarMatrReligioso || '',
    isRecognizedRite: castedMatrimonioAtti.flagRitoRiconosciuto === '1',
    // castedConsenso
    typologyConsent: castedConsenso?.tipoConsenso || '',
    idConsenso: castedConsenso?.key?.idConsenso,
    // dataLuogo
    idLuogo: dataLuogo?.key?.idLuogo || undefined,
    isForeign: dataLuogo?.idStato !== ID_ITALIAN_NATION,
    foreign:
      dataLuogo?.idStato && dataLuogo?.idStato !== ID_ITALIAN_NATION
        ? {
            state: {
              id: dataLuogo?.idStato?.toString() || '',
              value: isOtherState ? LABEL_ALTRO_STATO : dataLuogo?.nomeStato || '',
              code: dataLuogo?.idStato?.toString() || '',
            },
            otherState: isOtherState ? dataLuogo?.nomeStato : '',
          }
        : undefined,
    italian: dataLuogo?.idComune
      ? {
          municipality: {
            id: dataLuogo?.idComune?.toString(),
            code: dataLuogo?.idComune,
            description: isOtherMunicipality ? LABEL_ALTRO_COMUNE : dataLuogo?.nomeComune || '',
            idProvince: dataLuogo?.idProvincia || undefined,
            province: dataLuogo?.siglaProvincia || '',
          },
          otherMunicipality: isOtherMunicipality ? dataLuogo?.nomeComune : '',
        }
      : undefined,
    address: dataLuogo?.indirizzo || '',
    place: dataLuogo?.luogo || '',
    houseNumber: dataLuogo?.civico?.toString() || '',
    // castedEvento
    isWithInterprete:
      key === CodeSection.DATI_SPECIFICI_MATR ? castedEvento?.flagAusilioInterprete === '1' : false,
    presentationDocument: castedEvento?.tipoDatiProdotti || undefined,
    // castedRegimePatrimoniale
    propertyRegime: castedRegimePatrimoniale?.tipoRegimePatrimoniale || '',
    // castedDatiEventoRiconoscimento
    isSonUnderFourteen: castedDatiEventoRiconoscimento?.flagInfraQuattordicenne === '1',
    presentationDocumentRecognition: castedDatiEventoRiconoscimento?.datiProdotti || '',
    idDatiEventoRiconoscimento: castedDatiEventoRiconoscimento?.key?.idDatiEventoRiconoscimento,
    // castedTrascrizioneSeparazioneAtti
    ufcDelegate: castedDatiIntegrativiTrascrizione?.descrizioneUfficialeDelegante || '',
    reason: castedDatiIntegrativiTrascrizione?.motivoDelega || '',
  };

  return res;
};

const transformScioglimentoUnioneCivileAtti = (
  castedScioglimentoUnioneCivileAtti?: ScioglimentoUnioneCivileAtti,
  castedEvento?: Evento,
  castedLuogo?: Luogo
): Record<string, SectionVM> => {
  const res: Record<string, SectionVM> = {};

  if (!castedScioglimentoUnioneCivileAtti) {
    return res;
  }

  const key = castedScioglimentoUnioneCivileAtti.codiceSezione?.trim();
  const keySection = `section-${key}`;

  const dataLuogo = castedLuogo?.codiceSezione === key ? castedLuogo : {};

  const isOtherState = dataLuogo?.idStato?.toString() === ID_ALTRO_STATO;
  const isOtherMunicipality = dataLuogo?.idComune?.toString() === ID_ALTRO_COMUNE;

  res[keySection] = {
    isSaved: true,
    // castedScioglimentoUnioneCivileAtti
    isMaintenanceAllowance: castedScioglimentoUnioneCivileAtti.flagAssegnoMantenimento === '1',
    maintenanceAllowance: castedScioglimentoUnioneCivileAtti.descrizioneDatiAssegnoMantenim || '',
    isPendingJudgment: castedScioglimentoUnioneCivileAtti.flagInGiudizioPendente === '1',
    judicialAuthority: castedScioglimentoUnioneCivileAtti.descrizioneAutoritaGiudiziaria || '',
    isHusband: castedScioglimentoUnioneCivileAtti?.flagPresenzaConiuge1 == '1',
    isLawyerHusband: castedScioglimentoUnioneCivileAtti.flagPresenzaAvvConiuge1 === '1',
    isWife: castedScioglimentoUnioneCivileAtti?.flagPresenzaConiuge2 == '1',
    isLawyerWife: castedScioglimentoUnioneCivileAtti.flagPresenzaAvvConiuge2 === '1',
    dateMarriage: castedScioglimentoUnioneCivileAtti.dataUnioneCivile
      ? DateTime.fromISO(castedScioglimentoUnioneCivileAtti.dataUnioneCivile)
      : null,
    dateAgreementConfirmation: castedScioglimentoUnioneCivileAtti.dataConfermaAccordo
      ? DateTime.fromISO(castedScioglimentoUnioneCivileAtti.dataConfermaAccordo)
      : null,
    celebratedBy: castedScioglimentoUnioneCivileAtti?.descrizioneOfficianteUnioneCivile || '',
    dataSend: castedScioglimentoUnioneCivileAtti.dataComunicazione
      ? DateTime.fromISO(castedScioglimentoUnioneCivileAtti.dataComunicazione)
      : null,
    typeCommunication:
      castedScioglimentoUnioneCivileAtti.flagConRaccomandataAr === '1'
        ? { id: ID_COMMUNICATION.ID_RACCOMANDATA, value: '' }
        : castedScioglimentoUnioneCivileAtti.descrizioneAltroMezzoComunicaz
        ? { id: ID_COMMUNICATION.ID_ALTRO_MEZZO, value: '' }
        : undefined,
    otherTypeCommunicationDescription:
      castedScioglimentoUnioneCivileAtti?.descrizioneAltroMezzoComunicaz || '',
    address: castedScioglimentoUnioneCivileAtti.tipoIndirizzoComunicazione || '',
    dataReception: castedScioglimentoUnioneCivileAtti.dataRicezione
      ? DateTime.fromISO(castedScioglimentoUnioneCivileAtti.dataRicezione)
      : null,
    // castedEvento
    isWithInterprete: castedEvento?.flagAusilioInterprete === '1',
    // dataLuogo
    idLuogo: dataLuogo?.key?.idLuogo || undefined,
    isForeign: dataLuogo?.idStato !== ID_ITALIAN_NATION,
    foreign:
      dataLuogo?.idStato && dataLuogo?.idStato !== ID_ITALIAN_NATION
        ? {
            state: {
              id: dataLuogo?.idStato?.toString() || '',
              value: isOtherState ? LABEL_ALTRO_STATO : dataLuogo?.nomeStato || '',
              code: dataLuogo?.idStato?.toString() || '',
            },
            otherState: isOtherState ? dataLuogo.nomeStato : '',
          }
        : undefined,
    italian: dataLuogo?.idComune
      ? {
          municipality: {
            id: dataLuogo?.idComune?.toString(),
            code: dataLuogo?.idComune,
            description: isOtherMunicipality ? LABEL_ALTRO_COMUNE : dataLuogo?.nomeComune || '',
            idProvince: dataLuogo?.idProvincia || undefined,
            province: dataLuogo?.siglaProvincia || '',
          },
          otherMunicipality: isOtherMunicipality ? dataLuogo?.nomeComune : '',
        }
      : undefined,
  };

  return res;
};

const transformPubblicazioneList = (
  castedPubblicazioneList?: Array<Pubblicazione>,
  castedMatrimonioAtti?: MatrimonioAtti
): Record<string, SectionVM> => {
  const res: Record<string, SectionVM> = {};

  if ((castedPubblicazioneList || []).length === 0) {
    return res;
  }

  castedPubblicazioneList?.forEach((itemCastedPubblicazione) => {
    const key = itemCastedPubblicazione.codiceSezione?.trim();
    const keySection = `section-${key}`;

    const isOtherState = itemCastedPubblicazione?.idNazione?.toString() === ID_ALTRO_STATO;
    const isOtherMunicipality = itemCastedPubblicazione?.idComune?.toString() === ID_ALTRO_COMUNE;

    res[keySection] = {
      isSaved: true,
      // itemCastedPubblicazione
      idPubblicazione: itemCastedPubblicazione.key?.idPubblicazione || undefined,
      italian: itemCastedPubblicazione?.nomeComune
        ? {
            municipality: {
              description: isOtherMunicipality
                ? LABEL_ALTRO_COMUNE
                : itemCastedPubblicazione?.nomeComune || '',
              id: itemCastedPubblicazione?.idComune?.toString() || '',
              code: itemCastedPubblicazione?.idComune,
              idProvince: itemCastedPubblicazione?.idProvincia || undefined,
              province: itemCastedPubblicazione?.siglaProvincia || '',
            },
            otherMunicipality: isOtherMunicipality ? itemCastedPubblicazione?.nomeComune : '',
          }
        : undefined,
      foreign: itemCastedPubblicazione?.idNazione
        ? {
            state: {
              id: itemCastedPubblicazione?.idNazione.toString(),
              value: isOtherState ? LABEL_ALTRO_STATO : itemCastedPubblicazione?.nomeNazione || '',
              code: itemCastedPubblicazione?.idNazione.toString(),
            },
            otherState: isOtherState ? itemCastedPubblicazione?.nomeNazione : '',
            consulate: itemCastedPubblicazione?.anagraficaConsolato
              ? {
                  id: itemCastedPubblicazione?.anagraficaConsolato,
                  value: itemCastedPubblicazione?.nomeAnagraficaConsolato || '',
                }
              : undefined,
          }
        : undefined,
      isForeign: itemCastedPubblicazione?.idNazione !== ID_ITALIAN_NATION,
      dataStart: itemCastedPubblicazione?.dataInizio
        ? DateTime.fromISO(itemCastedPubblicazione?.dataInizio)
        : undefined,
      dataEnd: itemCastedPubblicazione?.dataFine
        ? DateTime.fromISO(itemCastedPubblicazione?.dataFine)
        : undefined,
      // castedMatrimonioAtti
      isReductionTerms:
        key === CodeSection.PUBBLICAZIONE_1
          ? castedMatrimonioAtti?.flagRiduzTerminiPubblicaz === '1'
          : undefined,
    };
  });

  return res;
};

const transformTrascrizioneUnioneCivile = (
  castedTrascrizioneUnioneCivile?: TrascrizioneUnioneCivile,
  castedUnioneCivileAtti?: UnioneCivileAtti,
  castedStatoCivile?: StatoCivile,
  castedDatiIntegrativiTrascrizione?: DatiIntegrativiTrascrizione
): Record<string, SectionVM> => {
  const res: Record<string, SectionVM> = {};

  if (!castedTrascrizioneUnioneCivile) {
    return res;
  }

  const key = castedTrascrizioneUnioneCivile.codiceSezione?.trim();
  const keySection = `section-${key}`;

  res[keySection] = {
    isSaved: true,
    // castedTrascrizioneUnioneCivile
    dateTranscription: castedTrascrizioneUnioneCivile.dataComunicazione
      ? DateTime.fromISO(castedTrascrizioneUnioneCivile.dataComunicazione)
      : null,
    templateTranscriptionText: castedTrascrizioneUnioneCivile.trascrizione || '',
    typeRequest: castedTrascrizioneUnioneCivile.dichiarazione || '',
    typeActToTranscribed: castedTrascrizioneUnioneCivile.tipoTrascrizione || '',
    // castedUnioneCivileAtti
    dataCivilUnion: castedUnioneCivileAtti?.dataEvento
      ? DateTime.fromISO(castedUnioneCivileAtti.dataEvento)
      : null,
    // castedDatiIntegrativiTrascrizione
    idTemplateIcaro: Boolean(castedStatoCivile?.idIcaro)
      ? castedDatiIntegrativiTrascrizione?.codiceTemplate || ''
      : '',
    // disableTemplate: Boolean(castedStatoCivile?.idIcaro),
  };

  return res;
};

const transformSeparazione = (
  castedSeparazione?: Separazione,
  castedLuogo?: Luogo,
  castedTrascrizioneSeparazioneAtti?: TrascrizioneSeparazioneAtti,
  castedStatoCivile?: StatoCivile,
  castedDatiIntegrativiTrascrizione?: DatiIntegrativiTrascrizione,
  castedEvento?: Evento
): Record<string, SectionVM> => {
  const res: Record<string, SectionVM> = {};

  if (!castedSeparazione) {
    return res;
  }

  const key = castedSeparazione.codiceSezione?.trim();
  const keySection = `section-${key}`;

  const dataLuogo = castedLuogo?.codiceSezione === key ? castedLuogo : {};

  const isOtherState = dataLuogo?.idStato?.toString() === ID_ALTRO_STATO;
  const isOtherMunicipality = dataLuogo?.idComune?.toString() === ID_ALTRO_COMUNE;

  res[keySection] = {
    isSaved: true,
    // castedSeparazione
    isMaintenanceAllowance: castedSeparazione.flagAssegnoMantenimento === '1',
    maintenanceAllowance: castedSeparazione.descrizioneDatiAssegnoMantenimento || '',
    isPendingJudgment: castedSeparazione.flagInGiudizioPendente === '1',
    judicialAuthority: castedSeparazione.descrizioneAutoritaGiudiziaria || '',
    isHusband: castedSeparazione.flagPresenzaConiuge1 == '1',
    isWife: castedSeparazione.flagPresenzaConiuge2 == '1',
    isLawyerHusband: castedSeparazione.flagPresenzaAvvConiuge1 == '1',
    isLawyerWife: castedSeparazione.flagPresenzaAvvConiuge2 == '1',
    dateMarriage: castedSeparazione.dataEventoMatrimonio
      ? DateTime.fromISO(castedSeparazione.dataEventoMatrimonio)
      : null,
    dateAgreementConfirmation: castedSeparazione.dataConfermaAccordo
      ? DateTime.fromISO(castedSeparazione.dataConfermaAccordo)
      : null,
    celebratedBy: castedSeparazione.descrizioneOfficianteEventoMatrimoni || '',
    typeAgreement: castedSeparazione.tipoAccordo || '',
    typeSeparation: castedSeparazione.tipoProvvedimentoSeparazione || '',
    typeEvent: castedSeparazione.tipoSeparazioneDivorzio || '',
    templateTranscriptionText: castedSeparazione.testoModificaAccordo || '',
    isLawyerHusbandWife: castedSeparazione.flagAvvocatoUnico === '1',
    // castedEvento
    isWithInterprete: castedEvento?.flagAusilioInterprete === '1',
    // castedDatiIntegrativiTrascrizione
    idTemplateIcaro: Boolean(castedStatoCivile?.idIcaro)
      ? castedDatiIntegrativiTrascrizione?.codiceTemplate || ''
      : '',
    // disableTemplate: Boolean(castedStatoCivile?.idIcaro),
    // dataLuogo
    idLuogo: dataLuogo?.key?.idLuogo || undefined,
    isForeign: dataLuogo?.idStato !== ID_ITALIAN_NATION,
    foreign:
      dataLuogo?.idStato && dataLuogo?.idStato !== ID_ITALIAN_NATION
        ? {
            state: {
              id: dataLuogo?.idStato?.toString() || '',
              value: isOtherState ? LABEL_ALTRO_STATO : dataLuogo?.nomeStato || '',
              code: dataLuogo?.idStato?.toString() || '',
            },
            otherState: isOtherState ? dataLuogo?.nomeStato : '',
          }
        : undefined,
    italian: dataLuogo?.idComune
      ? {
          municipality: {
            id: dataLuogo?.idComune?.toString(),
            code: dataLuogo?.idComune,
            description: isOtherMunicipality ? LABEL_ALTRO_COMUNE : dataLuogo?.nomeComune || '',
            idProvince: dataLuogo?.idProvincia || undefined,
            province: dataLuogo?.siglaProvincia || '',
          },
          otherMunicipality: isOtherMunicipality ? dataLuogo?.nomeComune : '',
        }
      : undefined,
    // castedTrascrizioneSeparazioneAtti
    typeModificationMarriage: castedTrascrizioneSeparazioneAtti?.idModificaMatrimonio || '',
  };

  return res;
};

const transformRiconciliazione = (
  castedRiconciliazione?: Riconciliazione,
  castedLuogo?: Luogo,
  castedSeparazione?: Separazione
): Record<string, SectionVM> => {
  const res: Record<string, SectionVM> = {};

  if (!castedRiconciliazione) {
    return res;
  }

  const key = castedRiconciliazione.codiceSezione?.trim();
  const keySection = `section-${key}`;

  const dataLuogo = castedLuogo?.codiceSezione === key ? castedLuogo : {};

  const isOtherState = dataLuogo?.idStato?.toString() === ID_ALTRO_STATO;
  const isOtherMunicipality = dataLuogo?.idComune?.toString() === ID_ALTRO_COMUNE;

  res[keySection] = {
    isSaved: true,
    // castedSeparazione
    dateMarriage: castedRiconciliazione.dataMatrimonio
      ? DateTime.fromISO(castedRiconciliazione.dataMatrimonio)
      : null,
    celebratedBy: castedRiconciliazione.descUfficianteMatrimonio || '',
    dateReconciliation: castedRiconciliazione.dataRiconciliazione
      ? DateTime.fromISO(castedRiconciliazione.dataRiconciliazione)
      : null,
    typeSeparation: castedSeparazione?.tipoProvvedimentoSeparazione || '',
    // dataLuogo
    idLuogo: dataLuogo?.key?.idLuogo || undefined,
    isForeign: dataLuogo?.idStato !== ID_ITALIAN_NATION,
    foreign:
      dataLuogo?.idStato && dataLuogo?.idStato !== ID_ITALIAN_NATION
        ? {
            state: {
              id: dataLuogo?.idStato?.toString() || '',
              value: isOtherState ? LABEL_ALTRO_STATO : dataLuogo?.nomeStato || '',
              code: dataLuogo?.idStato?.toString() || '',
            },
            otherState: isOtherState ? dataLuogo?.nomeStato : '',
          }
        : undefined,
    italian: dataLuogo?.idComune
      ? {
          municipality: {
            id: dataLuogo?.idComune?.toString(),
            code: dataLuogo?.idComune,
            description: isOtherMunicipality ? LABEL_ALTRO_COMUNE : dataLuogo?.nomeComune || '',
            idProvince: dataLuogo?.idProvincia || undefined,
            province: dataLuogo?.siglaProvincia || '',
          },
          otherMunicipality: isOtherMunicipality ? dataLuogo?.nomeComune : '',
        }
      : undefined,
  };

  return res;
};

const transformTrascrizioneMatrimonioAtti = (
  castedTrascrizioneMatrimonioAtti?: TrascrizioneMatrimonioAtti,
  castedMatrimonioAtti?: MatrimonioAtti,
  castedLuogo?: Luogo,
  castedStatoCivile?: StatoCivile,
  castedDatiIntegrativiTrascrizione?: DatiIntegrativiTrascrizione
): Record<string, SectionVM> => {
  const res: Record<string, SectionVM> = {};

  if (!castedTrascrizioneMatrimonioAtti) {
    return res;
  }

  const key = castedTrascrizioneMatrimonioAtti.codiceSezione?.trim();
  const keySection = `section-${key}`;

  const dataLuogo = castedLuogo?.codiceSezione === key ? castedLuogo : {};

  const isOtherState = dataLuogo?.idStato?.toString() === ID_ALTRO_STATO;
  const isOtherMunicipality = dataLuogo?.idComune?.toString() === ID_ALTRO_COMUNE;

  res[keySection] = {
    isSaved: true,
    // castedDatiIntegrativiTrascrizione
    idTemplateIcaro: Boolean(castedStatoCivile?.idIcaro)
      ? castedDatiIntegrativiTrascrizione?.codiceTemplate || ''
      : '',
    // disableTemplate: Boolean(castedStatoCivile?.idIcaro),
    // castedTrascrizioneMatrimonioAtti
    dateTranscription: castedTrascrizioneMatrimonioAtti.dataComunicazione
      ? DateTime.fromISO(castedTrascrizioneMatrimonioAtti.dataComunicazione)
      : null,
    templateTranscriptionText: castedTrascrizioneMatrimonioAtti.trascrizione || '',
    typeRequest: castedTrascrizioneMatrimonioAtti.dichiarazione || '',
    // castedUnioneCivileAtti
    dateEvent: castedMatrimonioAtti?.dataEvento
      ? DateTime.fromISO(castedMatrimonioAtti.dataEvento)
      : null,
    // dataLuogo
    idLuogo: dataLuogo?.key?.idLuogo || undefined,
    isForeign: dataLuogo?.idStato !== ID_ITALIAN_NATION,
    foreign:
      dataLuogo?.idStato && dataLuogo?.idStato !== ID_ITALIAN_NATION
        ? {
            state: {
              id: dataLuogo?.idStato?.toString() || '',
              value: isOtherState ? LABEL_ALTRO_STATO : dataLuogo?.nomeStato || '',
              code: dataLuogo?.idStato?.toString() || '',
            },
            otherState: isOtherState ? dataLuogo?.nomeStato : '',
            locationForeign: dataLuogo?.nomeComuneEstero || '',
          }
        : undefined,
    italian: dataLuogo?.idComune
      ? {
          municipality: {
            id: dataLuogo?.idComune?.toString(),
            code: dataLuogo?.idComune,
            description: isOtherMunicipality ? LABEL_ALTRO_COMUNE : dataLuogo?.nomeComune || '',
            idProvince: dataLuogo?.idProvincia || undefined,
            province: dataLuogo?.siglaProvincia || '',
          },
          otherMunicipality: isOtherMunicipality ? dataLuogo?.nomeComune : '',
        }
      : undefined,
  };

  return res;
};

const transformNegoziazioneAssistita = (
  castedNegoziazioneAssistita?: NegoziazioneAssistita
): Record<string, SectionVM> => {
  const res: Record<string, SectionVM> = {};

  if (!castedNegoziazioneAssistita) {
    return res;
  }

  const key = castedNegoziazioneAssistita.codiceSezione?.trim();
  const keySection = `section-${key}`;

  res[keySection] = {
    isSaved: true,
    // castedNegoziazioneAssistita
    typeAgreement: castedNegoziazioneAssistita.accordo || '',
    typeMeasure: castedNegoziazioneAssistita.provvedimento || '',
    receiptDocument: castedNegoziazioneAssistita.ricezioneAtto || '',
  };

  return res;
};

const transformRiferimentiPubblicazione = (
  castedRiferimentiPubblicazione?: RiferimentiPubblicazione
): Record<string, SectionVM> => {
  const res: Record<string, SectionVM> = {};

  if (!castedRiferimentiPubblicazione) {
    return res;
  }

  const key = castedRiferimentiPubblicazione.codiceSezione?.trim();
  const keySection = `section-${key}`;

  const publication: PublicationVM = {
    year: castedRiferimentiPubblicazione.numeroAnno?.toString() || '',
    number: castedRiferimentiPubblicazione.numeroAtto?.toString() || '',
    part: castedRiferimentiPubblicazione.codiceParte || '',
    serie: castedRiferimentiPubblicazione.codiceSerie || '',
    register: castedRiferimentiPubblicazione.codiceRegistro || '',
  };

  res[keySection] = {
    isSaved: true,
    // castedNegoziazioneAssistita
    filterPublication: publication,
    publicationData: publication,
  };

  return res;
};

const transformLeggeCittadinanza = (castedStatoCivile?: StatoCivile): Record<string, SectionVM> => {
  const res: Record<string, SectionVM> = {};

  if (!castedStatoCivile?.idMotivoVariazioneCittadinanza) {
    return res;
  }

  const key = CodeSection.LEGGE_CITTADINANZA;
  const keySection = `section-${key}`;

  res[keySection] = {
    isSaved: true,
    // castedStatoCivile
    numberLawCitizenship: castedStatoCivile?.idMotivoVariazioneCittadinanza || '',
  };

  return res;
};

const transformAnnotazioneModificativa = (
  castedAnnotazioneModificativa?: AnnotazioneModificativa
): Record<string, SectionVM> => {
  const res: Record<string, SectionVM> = {};

  if (!castedAnnotazioneModificativa) {
    return res;
  }

  const key = castedAnnotazioneModificativa.codiceSezione;
  const keySection = `section-${key}`;

  res[keySection] = {
    isSaved: true,
    // castedAnnotazioneModificativa
    changeSurname: castedAnnotazioneModificativa.modifica || '',
    oldSurnameRegistered:
      castedAnnotazioneModificativa.descrizioneVecchioCognomeIntestatario || null,
    newSurnameRegistered: castedAnnotazioneModificativa.descrizioneNuovoCognomeIntestatario || null,
    oldNameRegistered: castedAnnotazioneModificativa.descrizioneVecchioNomeIntestatario || null,
    newNameRegistered: castedAnnotazioneModificativa.descrizioneNuovoNomeIntestatario || null,
  };

  return res;
};

const transformDatiIntegrativiTrascrizione = (
  castedDatiIntegrativiTrascrizione?: DatiIntegrativiTrascrizione
): Record<string, SectionVM> => {
  const res: Record<string, SectionVM> = {};

  if (!castedDatiIntegrativiTrascrizione) {
    return res;
  }

  const key = castedDatiIntegrativiTrascrizione.codiceSezione?.trim();
  const keySection = `section-${key}`;

  res[keySection] = {
    isSaved: true,
    // castedDatiIntegrativiTrascrizione
    nameEditor: castedDatiIntegrativiTrascrizione.nomeRedattore || '',
    surnameEditor: castedDatiIntegrativiTrascrizione.cognomeRedattore || '',
    gender: castedDatiIntegrativiTrascrizione.sesso || '',
    timeDocumentFormation:
      castedDatiIntegrativiTrascrizione?.numeroOraDocumento?.toString() ||
      castedDatiIntegrativiTrascrizione?.numeroMinutoDocumento?.toString()
        ? DateTime.fromFormat(
            `${
              castedDatiIntegrativiTrascrizione.numeroOraDocumento?.toString().length === 1
                ? `0${castedDatiIntegrativiTrascrizione.numeroOraDocumento}`
                : castedDatiIntegrativiTrascrizione.numeroOraDocumento || '00'
            }:${
              castedDatiIntegrativiTrascrizione.numeroMinutoDocumento?.toString().length === 1
                ? `0${castedDatiIntegrativiTrascrizione.numeroMinutoDocumento}`
                : castedDatiIntegrativiTrascrizione.numeroMinutoDocumento || '00'
            }`,
            'HH:mm'
          )
        : null,
  };

  return res;
};

const transformTrascrizioneSeparazioneAtti = (
  castedTrascrizioneSeparazioneAtti?: TrascrizioneSeparazioneAtti,
  castedStatoCivile?: StatoCivile,
  castedDatiIntegrativiTrascrizione?: DatiIntegrativiTrascrizione
): Record<string, SectionVM> => {
  const res: Record<string, SectionVM> = {};

  if (!castedTrascrizioneSeparazioneAtti) {
    return res;
  }

  const key = castedTrascrizioneSeparazioneAtti.codiceSezione?.trim();
  const keySection = `section-${key}`;

  res[keySection] = {
    isSaved: true,
    // castedTrascrizioneSeparazioneAtti
    typeRequest: castedTrascrizioneSeparazioneAtti.tipoDichiarazione || '',
    isReceivedPrivateCitizen: castedTrascrizioneSeparazioneAtti.flagNotificaDaPrivCittad === '1',
    templateTranscriptionText: castedTrascrizioneSeparazioneAtti.trascrizione || '',
    dateTranscription: castedTrascrizioneSeparazioneAtti.dataComunicazione
      ? DateTime.fromISO(castedTrascrizioneSeparazioneAtti.dataComunicazione)
      : null,
    typeModificationMarriage: castedTrascrizioneSeparazioneAtti?.idModificaMatrimonio || '',
    // castedDatiIntegrativiTrascrizione
    idTemplateIcaro: Boolean(castedStatoCivile?.idIcaro)
      ? castedDatiIntegrativiTrascrizione?.codiceTemplate || ''
      : '',
    // disableTemplate: Boolean(castedStatoCivile?.idIcaro),
  };

  return res;
};

// La sezione "Atto assenso figlio reso" mostra consentReturnedBefore in un accordion separato, ma il dato
// è salvato dentro datiEventoRiconoscimento (oggetto posseduto dalla sezione dati generali riconoscimento).
// Questo step dedicato popola la sola sezione ATTO_ASSENSO_FIGLIO_RESO con quel valore, così l'accordion si
// ripopola al ricarico senza che la funzione della sezione generale debba occuparsi di un dato non suo.
const transformSectionAssensoFiglioReso = (
  castedDatiEventoRiconoscimento?: DatiEventoRiconoscimento
): Record<string, SectionVM> => {
  const res: Record<string, SectionVM> = {};

  if (!castedDatiEventoRiconoscimento?.descrizioneAssensoReso) {
    return res;
  }

  res[KeySections.keyAttoAssensoFiglioReso] = {
    isSaved: true,
    consentReturnedBefore: castedDatiEventoRiconoscimento.descrizioneAssensoReso,
    idDatiEventoRiconoscimento:
      castedDatiEventoRiconoscimento?.key?.idDatiEventoRiconoscimento || undefined,
  };

  return res;
};

export const transformSections = (data: DataWizardAct): Record<string, SectionVM> => {
  const castedDatiMorte: DatiMorte | undefined = data.datiMorte || undefined;
  const castedDatiEventoMorte: DatiEventoMorte | undefined = data.datiEventoMorte || undefined;
  const castedStatoCivile: StatoCivile | undefined = data.statoCivile || undefined;
  const castedEvento: Evento | undefined = data.evento || undefined;
  const castedDatiDichiarante: DatiDichiarante | undefined = data.datiDichiarante || undefined;
  const castedDatiEventoCittadinanza: DatiEventoCittadinanza | undefined =
    data.datiEventoCittadinanza || undefined;
  const castedCertificatoSanitario: CertificatoSanitario | undefined =
    data.certificatoSanitario || undefined;
  const castedDatiEventoRiconoscimento: DatiEventoRiconoscimento | undefined =
    data.datiEventoRiconoscimento || undefined;
  const castedEnteDichiaranteList: Array<EnteDichiaranteList> | undefined =
    data.enteDichiaranteList || undefined;
  const castedTrascrizioneMorte: TrascrizioneMorte | undefined =
    data.trascrizioneMorte || undefined;
  const castedTrascrizioneNascita: TrascrizioneNascita | undefined =
    data.trascrizioneNascita || undefined;
  const castedTrascrizioneCittadinanza: TrascrizioneCittadinanza | undefined =
    data.trascrizioneCittadinanza || undefined;
  const castedAttoCollegatoList: Array<AttoCollegato> | undefined =
    data.attoCollegatoList || undefined;
  const castedComposizione: Composizione | undefined = data.composizione;
  const castedConsenso: Consenso | undefined = data.consenso;
  const castedLuogo: Luogo | undefined = data.luogo;
  const castedDatiAssenso: DatiAssenso | undefined = data.datiAssenso;
  const castedDatiAnnotazioneList: Array<DatiAnnotazioneList> | undefined =
    data.datiAnnotazioneList;
  const castedUnioneCivileAtti: UnioneCivileAtti | undefined = data.unioneCivileAtti;
  const castedCertificatoUnioneCivileList: Array<CertificatoUnioneCivileList> | undefined =
    data.certificatoUnioneCivileList;
  const castedRegimePatrimoniale: RegimePatrimoniale | undefined = data.regimePatrimoniale;
  const castedImpedimentoList: Array<Impedimento> | undefined = data.impedimentoList;
  const castedMatrimonioAtti: MatrimonioAtti | undefined = data.matrimonioAtti;
  const castedScioglimentoUnioneCivileAtti: ScioglimentoUnioneCivileAtti | undefined =
    data.scioglimentoUnioneCivileAtti;
  const castedPubblicazioneList: Array<Pubblicazione> | undefined = data.pubblicazioneList;
  const castedTrascrizioneUnioneCivile: TrascrizioneUnioneCivile | undefined =
    data.trascrizioneUnioneCivile;
  const castedSeparazione: Separazione | undefined = data.separazione;
  const castedTrascrizioneMatrimonioAtti: TrascrizioneMatrimonioAtti | undefined =
    data.trascrizioneMatrimonioAtti;
  const castedNegoziazioneAssistita: NegoziazioneAssistita | undefined = data.negoziazioneAssistita;
  const castedDatiIntegrativiTrascrizione: DatiIntegrativiTrascrizione | undefined =
    data.datiIntegrativiTrascrizione;
  const castedTrascrizioneSeparazioneAtti: TrascrizioneSeparazioneAtti | undefined =
    data.trascrizioneSeparazioneAtti;
  const castedRiconciliazione: Riconciliazione | undefined = data.riconciliazione;
  const castedRiferimentiPubblicazione: RiferimentiPubblicazione | undefined =
    data.riferimentiPubblicazione;
  const castedRichiedente: Richiedente | undefined = data.richiedente;
  const castedAnnotazioneModificativa: AnnotazioneModificativa | undefined =
    data.annotazioneModificativa;

  const resMorte: Record<string, SectionVM> = transformSectionDead(
    castedDatiMorte,
    castedDatiEventoMorte,
    castedStatoCivile,
    castedEvento,
    castedDatiDichiarante
  );

  const resEnteDichiaranteListSections = transformSectionsEnteDichiarante(
    castedEnteDichiaranteList,
    castedTrascrizioneMorte,
    castedDatiEventoRiconoscimento,
    castedDatiEventoCittadinanza,
    castedImpedimentoList,
    data.riconoscimentoList,
    castedNegoziazioneAssistita,
    castedStatoCivile,
    castedDatiIntegrativiTrascrizione,
    castedTrascrizioneSeparazioneAtti
  );

  const resDatiGeneraliRiconoscimentoSection = transformSectionDatiGeneraliRiconoscimento(
    castedCertificatoSanitario,
    castedDatiEventoRiconoscimento,
    castedEvento,
    castedConsenso,
    castedDatiAssenso,
    data.riconoscimentoList
  );

  const resAssensoFiglioResoSection = transformSectionAssensoFiglioReso(
    castedDatiEventoRiconoscimento
  );

  const resTrascrizioneMorte = transformTrascrizioneMorte(
    castedTrascrizioneMorte,
    castedStatoCivile,
    castedDatiIntegrativiTrascrizione
  );

  const resTrascrizioneNascita = transformSectionTrascrizioneNascita(
    castedTrascrizioneNascita,
    castedEvento,
    castedEnteDichiaranteList,
    castedStatoCivile,
    castedDatiIntegrativiTrascrizione,
    castedRichiedente
  );

  const resTrascrizioneNascitaFiglioDiIgnoti =
    transformSectionTrascrizioneNascitaFiglioDiIgnoti(castedTrascrizioneNascita);

  const resDatiEventoCittadinanza = transformDatiEventoCittadinanza(
    castedDatiEventoCittadinanza,
    castedEvento,
    castedTrascrizioneCittadinanza,
    castedStatoCivile,
    castedDatiIntegrativiTrascrizione,
    castedTrascrizioneNascita
  );

  const resTrascrizioneCittadinanza = transformSectionTrascrizioneCittadinanza(
    castedTrascrizioneCittadinanza,
    castedStatoCivile,
    castedDatiIntegrativiTrascrizione
  );

  const resReceivedByPostTrascrizioneCittadinanza =
    transformSectionReceivedByPostTrascrizioneCittadinanza(castedTrascrizioneCittadinanza);

  const resAttoCollegatoList = transformAttoCollegatoList(
    castedAttoCollegatoList,
    castedConsenso,
    data.riconoscimentoList,
    castedStatoCivile
  );

  const resEventoSection = transformEventoSection(castedEvento, castedStatoCivile);

  const resComposizioneSection = transformComposizioneSection(
    castedComposizione,
    castedEvento,
    castedMatrimonioAtti,
    castedUnioneCivileAtti
  );

  const resConsensoSection = transformConsensoSection(
    castedConsenso,
    castedEvento,
    castedDatiEventoRiconoscimento
  );

  const resLuogoSection = transformLuogoSection(castedLuogo, castedTrascrizioneMorte);

  const resDatiAnnotazioneList = transformDatiAnnotazioneList(castedDatiAnnotazioneList);

  const resUnioneCivileAtti = transformUnioneCivileAtti(
    castedUnioneCivileAtti,
    castedEvento,
    castedLuogo,
    castedDatiIntegrativiTrascrizione
  );

  const resCertificatoUnioneCivileList = transformCertificatoUnioneCivileList(
    castedCertificatoUnioneCivileList
  );

  const resRegimePatrimoniale = transformRegimePatrimoniale(
    castedRegimePatrimoniale,
    castedDatiAnnotazioneList
  );

  const resMatrimonioAtti = transformMatrimonioAtti(
    castedMatrimonioAtti,
    castedEvento,
    castedLuogo,
    castedRegimePatrimoniale,
    castedDatiEventoRiconoscimento,
    castedConsenso,
    castedStatoCivile,
    castedDatiIntegrativiTrascrizione
  );

  const resScioglimentoUnioneCivileAtti = transformScioglimentoUnioneCivileAtti(
    castedScioglimentoUnioneCivileAtti,
    castedEvento,
    castedLuogo
  );

  const resPubblicazioneList = transformPubblicazioneList(
    castedPubblicazioneList,
    castedMatrimonioAtti
  );

  const resTrascrizioneUnioneCivile = transformTrascrizioneUnioneCivile(
    castedTrascrizioneUnioneCivile,
    castedUnioneCivileAtti,
    castedStatoCivile,
    castedDatiIntegrativiTrascrizione
  );

  const resSeparazione = transformSeparazione(
    castedSeparazione,
    castedLuogo,
    castedTrascrizioneSeparazioneAtti,
    castedStatoCivile,
    castedDatiIntegrativiTrascrizione,
    castedEvento
  );

  const resTrascrizioneMatrimonioAtti = transformTrascrizioneMatrimonioAtti(
    castedTrascrizioneMatrimonioAtti,
    castedMatrimonioAtti,
    castedLuogo,
    castedStatoCivile,
    castedDatiIntegrativiTrascrizione
  );

  const resNegoziazioneAssistita = transformNegoziazioneAssistita(castedNegoziazioneAssistita);

  const resDatiIntegrativiTrascrizione = transformDatiIntegrativiTrascrizione(
    castedDatiIntegrativiTrascrizione
  );

  const resTrascrizioneSeparazioneAtti = transformTrascrizioneSeparazioneAtti(
    castedTrascrizioneSeparazioneAtti,
    castedStatoCivile,
    castedDatiIntegrativiTrascrizione
  );

  const resRiconciliazione = transformRiconciliazione(
    castedRiconciliazione,
    castedLuogo,
    castedSeparazione
  );

  const resRiferimentiPubblicazione = transformRiferimentiPubblicazione(
    castedRiferimentiPubblicazione
  );

  const resLeggeCittadinanza = transformLeggeCittadinanza(castedStatoCivile);

  const resAnnotazioneModificativa = transformAnnotazioneModificativa(
    castedAnnotazioneModificativa
  );

  return {
    ...resMorte,
    ...resEnteDichiaranteListSections,
    ...resDatiGeneraliRiconoscimentoSection,
    ...resAssensoFiglioResoSection,
    ...resTrascrizioneMorte,
    ...resTrascrizioneNascita,
    ...resTrascrizioneNascitaFiglioDiIgnoti,
    ...resTrascrizioneCittadinanza,
    ...resReceivedByPostTrascrizioneCittadinanza,
    ...resDatiEventoCittadinanza,
    ...resAttoCollegatoList,
    ...resEventoSection,
    ...resComposizioneSection,
    ...resConsensoSection,
    ...resLuogoSection,
    ...resDatiAnnotazioneList,
    ...resUnioneCivileAtti,
    ...resCertificatoUnioneCivileList,
    ...resRegimePatrimoniale,
    ...resMatrimonioAtti,
    ...resScioglimentoUnioneCivileAtti,
    ...resPubblicazioneList,
    ...resTrascrizioneUnioneCivile,
    ...resSeparazione,
    ...resTrascrizioneMatrimonioAtti,
    ...resNegoziazioneAssistita,
    ...resDatiIntegrativiTrascrizione,
    ...resTrascrizioneSeparazioneAtti,
    ...resRiconciliazione,
    ...resRiferimentiPubblicazione,
    ...resLeggeCittadinanza,
    ...resAnnotazioneModificativa,
  };
};
